"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Image = _interopRequireDefault(require("./Image"));

exports.default = _Image.default;